var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 0.333252,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5551 10.094H17.5799C12.6419 10.094 10.6667 12.1679 10.6667 17.3527V23.5745C10.6667 28.7593 12.6419 30.8333 17.5799 30.8333H23.5055C28.4435 30.8333 30.4187 28.7593 30.4187 23.5745V21.5006M23.4168 12.3234C24.0785 14.8017 25.9253 16.7408 28.2955 17.446M24.5325 11.1515L16.7502 19.3228C16.454 19.6339 16.1577 20.2457 16.0984 20.6916L15.6738 23.8128C15.5157 24.9431 16.2762 25.7312 17.3527 25.5757L20.3254 25.1298C20.7402 25.0675 21.3228 24.7565 21.629 24.4454L29.4113 16.2741C30.7544 14.8638 31.3865 13.2254 29.4113 11.1515C27.4361 9.07754 25.8757 9.7412 24.5325 11.1515Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProduct);
export default __webpack_public_path__ + "static/media/edit-product.824242f21be64a98363d564d2145698e.svg";
export { ForwardRef as ReactComponent };